import { AxiosResponse } from "axios";
import { contributeAxios } from "../..";
import { Suggestion } from "../../../types/services";

export const createSuggestion = (
  data: Suggestion
): Promise<AxiosResponse<any>> => contributeAxios.post(`/suggestions`, data);
